import { render } from "./TodoList.vue?vue&type=template&id=25217d66&scoped=true"
import script from "./TodoList.vue?vue&type=script&lang=ts"
export * from "./TodoList.vue?vue&type=script&lang=ts"

import "./TodoList.vue?vue&type=style&index=0&id=25217d66&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-25217d66"

export default script